export default __webpack_public_path__ + "static/media/6.807d547a.jpg";